module.exports = __webpack_public_path__ + "img/19_50.cc8a730e.png";